var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-listing-related-item-align" },
    [
      _c("ObjectLink", {
        ref: "objectLink",
        attrs: {
          tooltipContent: _vm.tooltipContent,
          label: _vm.label,
          link: _vm.link,
          icon: _vm.icon,
          size: _vm.sizeLink,
          dataBot:
            "activities-listing_related-item__" +
            _vm.data.type +
            "-" +
            _vm.data.id
        }
      }),
      _vm._v(" "),
      _vm.isPhoneNumberVisible && _vm.isMobilePhoneNumberVisible
        ? _c(
            "div",
            [
              _c("InteractiveInfo", {
                attrs: {
                  type: "phone",
                  values: [_vm.data.phone_number, _vm.data.mobile_number],
                  variant: "icons",
                  size: _vm.sizeInteractiveInfo
                }
              })
            ],
            1
          )
        : _c(
            "div",
            [
              _vm.isPhoneNumberVisible
                ? _c("InteractiveInfo", {
                    attrs: {
                      type: "phone",
                      values: [_vm.data.phone_number],
                      size: _vm.sizeInteractiveInfo
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobilePhoneNumberVisible
                ? _c("InteractiveInfo", {
                    attrs: {
                      type: "mobile",
                      values: [_vm.data.mobile_number],
                      size: _vm.sizeInteractiveInfo
                    }
                  })
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }